













import { Component, Vue, Prop, PropSync } from 'vue-property-decorator'

@Component
export default class ConfirmDialog extends Vue {
  @PropSync('open', { default: false })
  public openSync !: boolean

  @Prop({ required: true })
  public message !: string;

  public cancel() {
    this.$emit('cancel')
  }

  public ok() {
    this.$emit('ok')
  }
}
